/**
 * Client-side GA4 dataLayer events, matching the reference theme:
 *   - select_item : fired when a product card is clicked
 *   - select_size : fired when a non-color variant option (e.g. Size) is chosen on the PDP
 *
 * Server-rendered events (view_item_list / view_item) and the GTM container live in
 * snippets/analytics-data-layer.liquid + snippets/analytics-gtm.liquid. This module is a no-op
 * unless those pushed a dataLayer (i.e. a GTM container is configured).
 */
(function () {
  const pushEvent = (payload) => {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push(payload);
  };

  // select_item — product card click (capture phase so it runs before the card's navigation).
  document.addEventListener(
    'click',
    (event) => {
      const target = event.target;
      if (!(target instanceof Element)) return;

      const card = target.closest('[data-gtm-item-id]');
      if (!card) return;

      const ecommerce = {
        items: [
          {
            item_id: card.dataset.gtmItemId,
            item_name: card.dataset.gtmItemName,
            item_brand: card.dataset.gtmItemBrand,
            item_type: card.dataset.gtmItemType,
            item_category: card.dataset.gtmItemCategory,
          },
        ],
      };

      if (card.dataset.gtmListId) ecommerce.item_list_id = card.dataset.gtmListId;
      if (card.dataset.gtmListName) ecommerce.item_list_name = card.dataset.gtmListName;

      pushEvent({ event: 'select_item', ecommerce });
    },
    true
  );

  // select_size — PDP variant option selection (non-color), matching the reference event.
  document.addEventListener('change', (event) => {
    const input = event.target;
    if (!(input instanceof HTMLInputElement) || input.type !== 'radio') return;
    if (!input.closest('variant-picker')) return;

    const optionName = (input.dataset.gtmOptionName || '').toLowerCase();
    if (!optionName || optionName === 'color' || optionName === 'colour') return;

    pushEvent({
      event: 'select_size',
      ecommerce: {
        item_id: input.dataset.variantId || input.dataset.optionValueId || '',
        size_selected: input.value,
      },
    });
  });
})();
